import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import classes from './HeaderCell.module.scss';

const HeaderCell = ({
  children,
  className,
  classNameTitle,
  title,
  ...other
}) => {
  return (
    <th className={cn(classes.base, className)} {...other}>
      <div className={cn(classes.content, classNameTitle)} {...other}>
        {title}
        {children}
      </div>
    </th>
  );
};

HeaderCell.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string,
  classNameTitle: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export default HeaderCell;
